import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid, Slider, Input, Typography } from "@material-ui/core";
import { translate } from "../../../../../infrastructure/translate/localization";
import { acceptEducation } from "../../../../../usecases/requests/accept-education";
import { hideModal } from "../../../../../usecases/commons/hide-modal";

import Modal from "../../Modal";
import CobeeButton from "../../../CobeeButton";

import useStyles from "./styles";
import { MonetaryAmount } from "../../../../domain/monetary-amount";

const MIN_VAL = 1;
const MAX_VAL = 60;

const marks = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 12,
    label: "12",
  },
  {
    value: 24,
    label: "24",
  },
  {
    value: 36,
    label: "36",
  },
  {
    value: 48,
    label: "48",
  },
  {
    value: 60,
    label: "60",
  },
];

export default function ApproveRequestFinancial({
  requestId,
  amount,
  fromFunds,
}) {
  const {
    textFee,
    paperContainer,
    input,
    textInfo,
    sliderContainer,
    sliderWrapper,
  } = useStyles();
  const [value, setValue] = useState(MIN_VAL);
  const [fetching, setFetch] = useState(false);

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleInputChange = (event) => {
    setValue(event.target.value === "" ? "" : Number(event.target.value));
  };

  const handleBlur = () => {
    if (value < MIN_VAL) {
      setValue(MIN_VAL);
    } else if (value > MAX_VAL) {
      setValue(MAX_VAL);
    }
  };

  const submitApprove = async () => {
    setFetch(true);
    await acceptEducation({
      splitBy: value,
      requestId,
      centsInPayroll: amount * 100,
      centsAmountFromFunds: fromFunds.amountInCents,
    });
    setFetch(false);
  };

  return (
    <Modal title={translate("request-section.approve-financial")}>
      <Grid container className={paperContainer} item xs={12}>
        <Grid item xs={12}>
          <Typography className={textInfo}>
            {translate("request-section.course-total-price")}:{" "}
            {MonetaryAmount.fromUnitary(amount).prettifyMoney({})}
          </Typography>
        </Grid>

        <Grid item xs={12} container className={sliderWrapper}>
          <Grid item xs={12}>
            <Typography className={textInfo}>
              {translate("request-section.number-of-payrolls-payment-message")}:
            </Typography>
          </Grid>

          <Grid container item xs={10} alignItems="center">
            <Slider
              className={sliderContainer}
              min={MIN_VAL}
              max={MAX_VAL}
              step={1}
              marks={marks}
              value={value}
              onChange={handleSliderChange}
            />
          </Grid>

          <Grid item xs={2}>
            <Grid container alignItems="center">
              <Input
                className={input}
                value={value}
                margin="dense"
                onChange={handleInputChange}
                onBlur={handleBlur}
                inputProps={{
                  step: 1,
                  min: 1,
                  max: 60,
                  type: "number",
                  "aria-labelledby": "input-slider",
                }}
              />
              <Typography className={textFee}>
                {translate("request-section.quotas")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Typography className={textInfo}>
            {translate("request-section.price-per-quota")}:{" "}
            {MonetaryAmount.fromUnitary(amount / value).prettifyMoney({})}
          </Typography>
        </Grid>

        <Grid container item xs={12} spacing={2} justify="center">
          <Grid item>
            <CobeeButton styleType="secondary" onClick={hideModal}>
              {translate("actions.cancel")}
            </CobeeButton>
          </Grid>
          <Grid item>
            <CobeeButton onClick={submitApprove} isLoading={fetching}>
              {translate("actions.approve")}
            </CobeeButton>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}

ApproveRequestFinancial.propTypes = {
  requestId: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  fromFunds: PropTypes.object.isRequired,
};
